import { isEmployeeUnderage } from '@/helpers/dateHelper';
import { SeverityType } from '@/services/warnings/warningDefinitions';
import { WorkingShift } from '@/types/daily.types';
import { EmployeeForShiftItem } from '@/types/employeeForShift.types';
import { RosterWarningModel, WarningsProps } from '../../../pages/roster/warnings/warnings.types';

export const getWarningsForUnderageNightShifts = (
  shift: WorkingShift,
  assignedEmployee: EmployeeForShiftItem,
  props: WarningsProps
): RosterWarningModel[] => {
  const { strings } = props;
  const shiftWarnings: RosterWarningModel[] = [];
  const employeeDateOfBirth = assignedEmployee.details?.dateOfBirth;

  if (employeeDateOfBirth && isEmployeeUnderage(employeeDateOfBirth) && shift.end! / (60 * 60) > 22) {
    shiftWarnings.push({
      severity: SeverityType.CRITICAL,
      name: strings.staffCannotBeAssigned.message,
      details: [strings.staffCannotBeAssigned.underAgeNightShift],
      shiftId: shift.id
    });
  }

  return shiftWarnings;
};
